define([
	"dojo/_base/declare",
	"csi/store/Nodes",
	"csi/table/matrix/ColumnRootMap",
	"csi/xml",
	"csi/xml/Query"
], function(declare, Nodes, ColumnRootMap, xml, Query) {

	var _apparelBOMSubtypesStore = new Nodes({
		typeNode: "ApparelBOMSubtype",
		filterQuery: new Query().Attr("Published", xml.OP_EQUALS, true)
	});

	return declare(ColumnRootMap, {
		hideLoneSubheader: true,
		mapKeyColumnId: "Node Name",
		mapKeyRowId: "Node Name",

		addDeferred: function(ctx, h, dfds) {
			dfds.push(_apparelBOMSubtypesStore.query());
			this.inherited(arguments);
		},

		_getColumnNodes: function(ctx, h) {
			return _apparelBOMSubtypesStore.query();
		},

		_getSpecNodes: function(ctx, spec, nodes) {
			return [ctx.view.cacheView.getNode("centric://REFLECTION/INSTANCE/MaterialPlanPlacementConfig/SetupSettings")];
		}

	});
});